import * as React from "react";
import { capitalize } from "lodash";

interface DynamicIconProps {
    name: string;
    suffix?: string;
    nativeColor: string;
    size?: 16 | 24 | 32;
    iconProps?: any;
}

interface DynamicIconState {
    icon: any;
}

class DynamicIcon extends React.Component<DynamicIconProps, DynamicIconState> {
    state: DynamicIconState = {
        icon: null
    };
    
    async componentDidMount() {
        await this.addIcon(`${capitalize(this.props.name)}${this.props.suffix || "Icon"}`);
    }

    async componentWillReceiveProps(newProps: DynamicIconProps) {
        await this.addIcon(`${capitalize(newProps.name)}${newProps.suffix || "Icon"}`);
    }

    render() {
        const Icon = this.state.icon;
        const { nativeColor, size, iconProps } = this.props;

        if (!Icon) {
            return null;
        }

        return <Icon {...iconProps} nativeColor={nativeColor} size={size} />;
    }

    addIcon = async (name) => {
        import(`./${name}`)
            .then((icon) => {
                this.setState({
                    icon: icon.default
                });
            })
            .catch((error) => {
                window.console.error(`"${name}" not found`);
            });
    }
}

export default DynamicIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/DynamicIcon.tsx